import { isMobile } from 'react-device-detect';
export const bannerConfig = {
  banner_iteration: isMobile ? 3 : 5,
  section_banner_iteration: isMobile ? 2 : 3
};
